import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Box from '@material-ui/core/Box';
import InputBase from '@material-ui/core/InputBase';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  inputBaseBox: {
    backgroundColor: theme.palette.common.white,
  },
  inputBase: {
    height: '100%',
    padding: theme.spacing(0, 2),
  },
}));

const LabelTextField = ({
  label = null,
  ...props
}) => {
  const classes = useStyles();
  return (
    <Box width={1} fontSize="body1.fontSize" flexGrow={1}>
      <Grid container wrap="nowrap">
        <Grid item xs={3}>
          <Box px={2} py={1} textAlign="center" bgcolor="primary.main">
            {label}
          </Box>
        </Grid>
        <Grid item xs>
          <Box className={classes.inputBaseBox} height={1}>
            <InputBase
              className={classes.inputBase}
              fullWidth
              {...props} // eslint-disable-line
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LabelTextField;
